/* eslint no-undef: "warn" */
import React, { useEffect, useState } from 'react'

// Main Chakra UI components:
import {
    Box,
    Button,
    Center,
    HStack as ChakraHStack,
    Image,
    Link,
    List,
    ListItem,
    OrderedList,
    Text,
    UnorderedList,
    VStack,
} from '@chakra-ui/react'

import 'remixicon/fonts/remixicon.css'

import useMatchMedia from './MatchMedia'
import {
    actionColors,
    cursorColors,
    ActionBar,
    HStack,
    NotePane,
    SectionHeader,
    SubsectionHeader,
    RadialImage,
    RectImage,
    style,
} from './PlayersGuideUtil'

const PlayersGuideSneaking = () => {
    const isDesktopResolution = useMatchMedia('(min-width:992px)', true)

    return (
        <VStack mt={style.sectionSpacing} spacing={style.defaultSpacing}>
            <Center h={'75px'}>
                <SectionHeader id="sneaking">Sneaking</SectionHeader>
            </Center>
            <HStack>
                <Text style={{ width: isDesktopResolution ? '60%' : '100%' }}>
                    Moving through the shadows, avoiding detection, landing a devastating stroke to dispatch a powerful enemy. 
                    Sneaking is a powerful tool in your arsenal, and can be used to bypass difficult encounters, scout ahead for 
                    resources, or to gain an upper hand in combat.
                    <br/>
                    <br/>
                    Sneaking is not strictly necessary, but you'll find it a handy tool, and an expert rogue can dispatch even the strongest enemies with a single attack, it's very satisfying and can turn the tide of an otherwise unwinnable battle!
                </Text>
                <RectImage
                    src='/playersguide/treasure-vault.png'
                    alt='cast spell menu'
                    maxWidth={'40%'}
                    heading={'A treasure vault with an obelisk in it, a very lucky find!'}
                />
            </HStack>
        </VStack>
    )
}

export default PlayersGuideSneaking
